import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
@Pipe({
  name: 'timezoneConverter'
})
export class TimezoneConverterPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const UTCDate = args[0];
    const firstSession = args[1];
    if (value.online_locations.length > 0) {
      const localDate = this.convertTZ(UTCDate, firstSession, Intl.DateTimeFormat().resolvedOptions().timeZone);
      return localDate;
    } else {
      const localDate = this.convertTZ(UTCDate, firstSession, value.venue.time_zone);
      return localDate;
    }
  }

  convertTZ(UTCDate, firstSession, tzString) {
    let date = moment.utc(UTCDate, null).tz(tzString).format('MMM DD, yyyy');
    let time = moment.utc(firstSession, null).tz(tzString).format('h:mma');
    return date+ ' @'+time;
    }

}
